import { __ } from '../../../i18n/l10n';
import { GRSkinId, GRSkinIds } from '../types/global';
import { GRRounds } from '../types/round';

export const getGRLabelsBySkinId = (skinId: GRSkinId) => {
  if (skinId === GRSkinIds.GIFT_RACE) {
    return {
      OperationTitle: __('The Gift Race'),
      TabBarLabel: __('Xmas'),
      Enrollment: {
        // __('Complete all 3 phases of the game by placing winning bets and walk away with legendary gifts and lots of Freebets:')
        mainDescription: __(
          'Complete all 3 phases of the game by placing winning bets and walk away with legendary gifts and lots of Freebets:',
        ),
      },
      StepTitleByStepId: {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        [GRRounds.SHOE]: `${__('Level %1$s', 1)}`,
        [GRRounds.BALLOON]: `${__('Level %1$s', 2)}`,
        [GRRounds.SHIRT]: `${__('Level %1$s', 3)}`,
      },
      EndingLabel: __('Christmas is already over!'),
    };
  }

  if (skinId === GRSkinIds.HUNTING_ALL_STARS) {
    return {
      OperationTitle: __('Hunting All-Stars'),
      TabBarLabel: __('Hunting'),
      Enrollment: {
        mainDescription: __('!desc:HuntingAllStarsEnrollmentMainDescription'),
      },
      StepTitleByStepId: {
        // eslint-disable-next-line sonarjs/no-duplicate-string
        [GRRounds.SHOE]: `${__('Level %1$s', 1)}`,
        [GRRounds.BALLOON]: `${__('Level %1$s', 2)}`,
        [GRRounds.SHIRT]: `${__('Level %1$s', 3)}`,
      },
      EndingLabel: __('The hunt is over'),
    };
  }
};
